import { Users } from "lucide-react"

import { SectionSidebarLayout } from "./SectionSidebarLayout"

export function CustomersSectionLayout() {
  return (
    <SectionSidebarLayout
      navId="customers"
      navItems={[{ icon: Users, label: "All customers", to: "/customers" }]}
    />
  )
}
